import { render, staticRenderFns } from "./mobile_orderDetail.vue?vue&type=template&id=5e834a18&scoped=true&"
import script from "./mobile_orderDetail.vue?vue&type=script&lang=js&"
export * from "./mobile_orderDetail.vue?vue&type=script&lang=js&"
import style0 from "./mobile_orderDetail.vue?vue&type=style&index=0&id=5e834a18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e834a18",
  null
  
)

export default component.exports